import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Textarea } from '../../ui/textarea';
import { Card, Pill, PrimaryButton } from '../ui';
import { adminApi } from '../../../pages/journey/journeyApi';

const F = [['planned', 'Planned'], ['completed', 'Completed'], ['pending', 'Pending'], ['blockers', 'Blockers'], ['support_requested', 'Support requested'], ['reflection', 'Reflection']];
const inp = 'w-full border border-slate-200 rounded-xl px-3 py-2 text-sm';

const CheckinCard = ({ c, catalog, onDone }) => {
  const coaches = catalog.staff.filter((x) => x.roles.includes('coach'));
  const [f, setF] = useState({ coach_id: coaches[0]?.id, observations: c.observations || '', next: (c.next_actions || []).join('\n'), owner: c.owner || '', meet_link: c.meet_link || '', assign_extra: '' });
  const save = async () => {
    try {
      await adminApi(`/checkins/${c.id}`, { method: 'PUT', body: { coach_id: f.coach_id, observations: f.observations, next_actions: f.next.split('\n'), owner: f.owner, meet_link: f.meet_link, assign_extra: f.assign_extra } });
      toast.success('Check-in recorded; student journey updated'); onDone();
    } catch (e) { toast.error(e.message); }
  };
  return (
    <Card data-testid={`admin-checkin-${c.id}`}>
      <div className="flex flex-wrap items-center gap-2 mb-3"><p className="font-outfit font-semibold text-[#0b1f4d]">{c.student_name} · Week {c.week}</p>
        <Pill className={c.status === 'reviewed' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-50 text-amber-700'}>{c.status}</Pill>
        <span className="text-xs text-slate-500">confidence {c.confidence}/5 · progress {Object.entries(c.progress_snapshot || {}).map(([k, v]) => `${k} ${v}%`).join(', ')}</span></div>
      <div className="grid md:grid-cols-3 gap-x-6 gap-y-2 text-sm mb-4">{F.map(([k, l]) => <p key={k}><span className="text-xs text-slate-500 block">{l}</span>{c[k] || '—'}</p>)}</div>
      <div className="grid md:grid-cols-2 gap-3 text-sm">
        <label>Coach observations<Textarea rows={2} value={f.observations} onChange={(e) => setF({ ...f, observations: e.target.value })} data-testid="checkin-observations-input" /></label>
        <label>Agreed next actions (one per line)<Textarea rows={2} value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} data-testid="checkin-next-actions-input" /></label>
        <label>Assign additional practice (optional)<input value={f.assign_extra} onChange={(e) => setF({ ...f, assign_extra: e.target.value })} className={inp} data-testid="checkin-assign-extra-input" /></label>
        <label>Follow-up owner<input value={f.owner} onChange={(e) => setF({ ...f, owner: e.target.value })} className={inp} data-testid="checkin-owner-input" /></label>
        <label>Google Meet link<input value={f.meet_link} onChange={(e) => setF({ ...f, meet_link: e.target.value })} placeholder="https://meet.google.com/…" className={inp} data-testid="checkin-meet-input" /></label>
        <label>Coach<select value={f.coach_id} onChange={(e) => setF({ ...f, coach_id: e.target.value })} className={inp}>{coaches.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}</select></label>
      </div>
      <PrimaryButton onClick={save} className="mt-4" data-testid="checkin-review-save-btn">Record check-in</PrimaryButton>
    </Card>
  );
};

export const AdminCheckins = ({ catalog }) => {
  const [list, setList] = useState(null);
  const load = useCallback(() => adminApi('/checkins').then(setList).catch((e) => toast.error(e.message)), []);
  useEffect(() => { load(); }, [load]);
  return (
    <div className="space-y-4 max-w-5xl" data-testid="admin-checkins">
      {list && !list.length && <Card className="text-sm text-slate-500">No check-ins submitted yet.</Card>}
      {list?.map((c) => <CheckinCard key={c.id + c.status} c={c} catalog={catalog} onDone={load} />)}
    </div>
  );
};
